import React, { useEffect, Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import isToken from "../../../helpers/token-check";

import PrivateRoute from "../../PrivateRoute/container";
import PublicRoute from "./PublicRoute";
import AffiliateRoute from "./AffiliateRoute";
import EventCalendarContainer from "../../EventCalendar";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const YourReferralLinkNew = React.lazy(() =>
  import("../../Settings/components/Referral/YourReferralLinkNew")
);
const AuthWeChatCallback = React.lazy(() => import("../../AuthWeChatCallback"));
const PaypalSuccessfulRefNew = React.lazy(() =>
  import("../../Settings/components/Referral/PaypalSuccessfulRefNew")
);
const Login = React.lazy(() => import("../../Login/container"));
const Intermediate = React.lazy(() => import("../../Intermediate/container"));
const TermsAndConditions = React.lazy(() =>
  import("../../TermsAndConditions/container")
);
const Home = React.lazy(() => import("../../Home/container"));
const PublicParentTab = React.lazy(() =>
  import("../../PublicFeature/parentTab")
);
const PopularSpikes = React.lazy(() => import("../../PopularSpikes/container"));
const Notification = React.lazy(() => import("../../Notification/container"));
const SingleNotificationContainer = React.lazy(() =>
  import("../../Notification/singleNotificationContainer")
);
const CompanyParentTab = React.lazy(() =>
  import("../../CompanyPage/CompanyPageWithBanner")
);
const DashboardParentTab = React.lazy(() =>
  import("../../Dashboard2/parentTab")
);
const Onboard = React.lazy(() => import("../../Onboard"));
const InvestorParentTab = React.lazy(() =>
  import("../../InvestorsPage/parentTab")
);
// const InvestorPage = React.lazy(() => import("../../InvestorsPage/container"
const LeaderboardTable = React.lazy(() =>
  import("../../LeaderboardTable/container")
);
const VideosParentTab = React.lazy(() => import("../../Videos/parentTab"));
const VideoPlay = React.lazy(() => import("../../Videos/videoplayContainer"));
const WebPurchaseComp = React.lazy(() => import("../../WebPurchase/container"));
const PageNotFound = React.lazy(() => import("../../Errors/PageNotFound"));
// TODO Serve other error pages
// const InternetConnectionLost = React.lazy(() => import("../../Errors/InternetConnectionLost"));
const ServerError = React.lazy(() => import("../../Errors/ServerError"));
const SystemUpdate = React.lazy(() => import("../../Errors/SystemUpdate"));
const Baiting = React.lazy(() =>
  import("../../SpikeUniverse/components/BaitingPage/container")
);
const SpikeUniverseParentTab = React.lazy(() =>
  import("../../SpikeUniverse/parentTab")
);
const CreateSpikesWrapper = React.lazy(() =>
  import("../../SpikeUniverse/components/CreateSpikeWrapper/container")
);
const Top100ManagersParentTab = React.lazy(() =>
  import("../../Top100Managers/parentTab")
);
// const Courses = React.lazy(() => import("../../Learn/Courses"
// const Course = React.lazy(() => import("../../Learn/Course"
// const Resource = React.lazy(() => import("../../Learn/Resource"
// const ResourceCategory = React.lazy(() => import("../../Learn/ResourceCategory"
// const ResourceContent = React.lazy(() => import("../../Learn/ResourceContent"
const CheckPrivatePublic = React.lazy(() => import("./checkPrivatePublic"));
const AppleUserDetails = React.lazy(() =>
  import("../../Login/components/appleUserDetails")
);
const Wisdom = React.lazy(() => import("../../Wisdom/container"));
const CheckoutNew = React.lazy(() => import("../../CheckoutNew/container"));
const LogoutContainer = React.lazy(() => import("../../Login/logoutContainer"));
const PopularInsidersParentTab = React.lazy(() =>
  import("../../PopularInsiders/parentTab")
);
const WelcomeVideo = React.lazy(() =>
  import("../../WelcomeVideo/WelcomeVideo")
);
const WelcomeCrypto = React.lazy(() =>
  import("../../WelcomeCrypto/WelcomeVideo")
);
const MembersArea = React.lazy(() => import("../../MembersArea/container"));
const AffiliateRedirect = React.lazy(() => import("./AffiliateRedirect"));
const AdvanceRoute = React.lazy(() => import("./AdvanceRoute"));
const InvestorArkParentTab = React.lazy(() =>
  import("../../ArkFeature/ArkInvestorPage/parentTab")
);
const CompanyArkParentTab = React.lazy(() =>
  import("../../ArkFeature/ArkCompanyPage/parentTab")
);
const Line = React.lazy(() => import("../../Ark/line"));
const Bar = React.lazy(() => import("../../Ark/bar"));
const Tree = React.lazy(() => import("../../Ark/tree"));
const Trends = React.lazy(() => import("../../Ark/trends"));
const InsiderMember = React.lazy(() => import("../../InsiderMember/container"));
const InsiderCheckout = React.lazy(() =>
  import("../../InsiderCheckout/container")
);
const WelcomeInsider = React.lazy(() =>
  import("../../WelcomeMembership/container")
);
const FundsParentTab = React.lazy(() => import("../../Funds"));
const CheckoutGrabPay = React.lazy(() => import("../../CheckoutGrabPay"));
const GrabPayCallback = React.lazy(() => import("../../GrabPayCallback"));
const Calendar = React.lazy(() => import("../../Calendar/container"));
const LayoutRoute = React.lazy(() => import("../../WebPurchase/LayoutRoute"));
const LessonContainer = React.lazy(() => import("../../Lesson/container"));
const EventHistory = React.lazy(() =>
  import("../../Challenge/components/History/EventHistory")
);
const Challenge = React.lazy(() => import("../../Challenge"));
const ChallengePerformance = React.lazy(() =>
  import("../../Challenge/components/Performance/Me")
);
const ChallengePerformanceComparison = React.lazy(() =>
  import("../../Challenge/components/Performance/Others")
);
const ChallengeLeaderboard = React.lazy(() =>
  import("../../Challenge/components/Leaderboard")
);
const Portfolio = React.lazy(() =>
  import("../../Challenge/components/Portfolio/Portfolio")
);
const Trading = React.lazy(() =>
  import("../../Challenge/components/Trading/Trading")
);
const ChallengeActivity = React.lazy(() =>
  import("../../Challenge/components/Activity")
);
const CopyTradePortfolio = React.lazy(() =>
  import("../../CopyTrade/Portfolio")
);
const DiscoverCopyTrade = React.lazy(() => import("../../CopyTrade/Discover"));
const PersonalInformation = React.lazy(() =>
  import("../../UserProfile/PersonalInfomation")
);
const Accomplishments = React.lazy(() =>
  import("../../UserProfile/Accomplishments")
);
const TradeProfile = React.lazy(() => import("../../UserProfile/TradeProfile"));
const ProfileCalendar = React.lazy(() => import("../../UserProfile/Calendar"));
const ProfileNotification = React.lazy(() =>
  import("../../UserProfile/Notification")
);
const DangerZone = React.lazy(() => import("../../UserProfile/DangerZone"));
const CoursesNew = React.lazy(() => import("../../Courses"));
const ClassReplays = React.lazy(() => import("../../Courses/ClassReplays"));
const Billing = React.lazy(() => import("../../UserProfile/Billing"));
const Subscriptions = React.lazy(() => import("../../UserProfile/Subscription"));
const GridInput = React.lazy(() => import("../../UserProfile/GridInput"));
const PublicHaradaView = React.lazy(() =>
  import("../../UserProfile/GridInput/PublicHaradaView")
);
const LoginLandingPage = React.lazy(() => import("../../LoginNew/LandingPage"));
const ATVLoginPage = React.lazy(() =>
  import("../../LoginNew/LandingPage/atvLogin")
);
const EmailLogin = React.lazy(() => import("../../LoginNew/EmailLogin"));
const ForgotPassword = React.lazy(() =>
  import("../../LoginNew/ForgotPassword")
);
const ResetPassword = React.lazy(() => import("../../LoginNew/ResetPassword"));
const MagicLink = React.lazy(() => import("../../LoginNew/MagicLink"));
const CreateAccount = React.lazy(() => import("../../LoginNew/CreateAccount"));
const Following = React.lazy(() => import("../../UserProfile/Following"));
const TradePortfolio = React.lazy(() =>
  import("../../CopyTrade/TradePortfolio")
);
const TradingDiary = React.lazy(() => import("../../UserProfile/TradingDiary"));
const VideoLibrary = React.lazy(() => import("../../VideoLibrary"));
const Membership = React.lazy(() => import("../../UserProfile/Membership"));
const CodeOfHonor = React.lazy(() => import("../../UserProfile/CodeOfHonor"));
const TradeHistory = React.lazy(() => import("../../CopyTrade/TradeHistory"));
const MillionDollarTrade = React.lazy(() => import("../../MillionDollarTrade"));
const SpikingUpDown = React.lazy(() => import("../../SpikingUpDown"));
const Discover = React.lazy(() => import("../../Discover"));
const TradeGPT = React.lazy(() => import("../../TradeGPT"));
const BasicCourse = React.lazy(() => import("../../BasicCourse"));
const StocksAI = React.lazy(() => import("../../StocksAI"));
const OptionsAI = React.lazy(() => import("../../OptionsAI"));
const Blocks = React.lazy(() => import("../../Blocks"));
const Spike = React.lazy(() => import("../../Spike"));
const OptionsCompanyParentTab = React.lazy(() =>
  import("../../OptionsDashboard/components/CompanyPage/OptionsCompanyPage")
);
const Disclaimer = React.lazy(() => import("./Disclaimer"));
const TradeGptSectors = React.lazy(() =>
  import("../../TradeGPT/TradeGptSectors")
);
const TradeGptPrompt = React.lazy(() =>
  import("../../TradeGPT/TradeGPTPrompt")
);
const HolyGrail = React.lazy(() => import("../../HolyGrail"));
const EventsCalendar = React.lazy(() =>
  import("../../Calendar/EventsCalendar")
);
const Workbook = React.lazy(() => import("../../Workbook"));
const NewCryptos = React.lazy(() => import("../../CryptosAI/NewCryptos"));
const Wallet = React.lazy(() => import("../../CryptosAI-2/Wallet"));
const UserWallet = React.lazy(() => import("../../UserProfile/Wallet"));
const Referral = React.lazy(() => import("../../UserProfile/Referral"));
const BlockChain = React.lazy(() => import("../../BlockChain"));
const DiscoverNew = React.lazy(() => import("../../DiscoverNew"));
const Track = React.lazy(() => import("../../Track"));
const Shop = React.lazy(() => import("../../Shop"));
const Journey = React.lazy(() => import("../../Journey"));
const JourneyATV = React.lazy(() => import("../../Journey/indexatv"));
const YoutubePlayer = React.lazy(() => import("../../YoutubePlayer"));
const Kickoff = React.lazy(() => import("../../Kickoff"));
const SpikingAILogin = React.lazy(() => import("../../SpikingAI/Login/index"));
const PricingPremium = React.lazy(() => import("../../PricingPremium"));
const Newsletter = React.lazy(() => import("../../Newsletter"));
const ExternalRedirect = React.lazy(() => import("./ExternalRedirect"));
const OptionsTradingLanding = React.lazy(() =>
  import("../../StaticHtmlLanding").then((module) => ({
    default: module.OptionsTradingLanding,
  }))
);
const Options56Landing = React.lazy(() =>
  import("../../StaticHtmlLanding").then((module) => ({
    default: module.Options56Landing,
  }))
);
const TopBuySell = React.lazy(() => import("../../TopBuySell"));
const SmartMoneyMarginScreen = React.lazy(() => import("../../Claude/SmartMoneyMarginScreen"));
const PortfolioRiskDashboard = React.lazy(() => import("../../Claude/PortfolioRiskDashboard"));

const PublicSectorPage = React.lazy(() => import("../../PublicProduct/Sector"));
const PublicHolyGrailPage = React.lazy(() =>
  import("../../PublicProduct/Holygrail")
);
const PublicDailyBreadPage = React.lazy(() =>
  import("../../PublicProduct/DailyBread")
);
const Top30AIStockPage = React.lazy(() =>
  import("../../PublicProduct/Top30AIStock")
);
const PublicYTDPage = React.lazy(() => import("../../PublicProduct/YTD"));
const Public200SMAPPage = React.lazy(() =>
  import("../../PublicProduct/200SMA")
);
const StockPerformance = React.lazy(() => import("../../StockPerformance"));
const LandPage = React.lazy(() => import("../../Land"));
const HodlPage = React.lazy(() => import("../../Hodl"));
const PropertyToolsPage = React.lazy(() => import("../../PropertyTools"));
const LEGACY_REDIRECT_TARGET = "https://spiking.com/stocks/dailybread";
const LegacyDailyBreadRedirect = () => (
  <Suspense fallback={<div className="p-6 text-center">Loading...</div>}>
    <ExternalRedirect url={LEGACY_REDIRECT_TARGET} />
  </Suspense>
);

const dailytrades_route_group = [
  { path: "/dailytrades", component: PublicParentTab },
  { path: "/watchlist", component: PublicParentTab },
  { path: "/trader", exact: true, component: PublicParentTab },
  // { path: "/whalewatching", component: WhaleWatching },
];

const company_route_group = [
  { path: "/company/fundamentals/:cid", component: CompanyParentTab },
  { path: "/company/insider/:cid/bought", component: CompanyParentTab },
  { path: "/company/insider/:cid/sold", component: CompanyParentTab },
  { path: "/company/insider/:cid/call", component: CompanyParentTab },
  { path: "/company/insider/:cid/put", component: CompanyParentTab },
  { path: "/company/insider/:cid", component: CompanyParentTab },
  { path: "/company/alerts/:cid", component: CompanyParentTab },
  { path: "/company/technical/:cid", component: CompanyParentTab },
  { path: "/company/shareholders/:cid", component: CompanyParentTab },
  { path: "/company/100investors/:cid", component: CompanyParentTab },
  { path: "/company/events/:cid", component: CompanyParentTab },
  { path: "/company/options/:cid", component: CompanyParentTab },
  { path: "/company/catchthespikes/:cid", component: CompanyParentTab },
  { path: "/company/earnings/:cid", component: CompanyParentTab },
];

const investor_route_group = [
  { path: "/bluewhale/:bid", component: InvestorParentTab },
  // { path: "/bluewhale/:bid", component: InvestorPage },
];

const courses_route_group_private = [
  { path: "/onboarding/:step_id?", exact: true, component: Onboard },
  { path: "/spikingai-login", exact: true, component: SpikingAILogin },
];

// const learn_route_group = [
//   { path: "/learn/courses", exact: true, component: Courses },
//   { path: "/learn/course/", exact: true, component: Course },
//   { path: "/learn/resource", exact: true, component: Resource },
//   { path: "/learn/resourceCategory", exact: true, component: ResourceCategory },
//   { path: "/learn/resourceContent", exact: true, component: ResourceContent },
//   // TODO Change to path with id when there is data
//   // { path: "/learn/course/:id", exact: true, component: Courses },
// ]

const baiting_route_group = [
  { path: "/baiting", exact: true, component: Baiting },
];

const spike_universe_route_group = [
  { path: "/explorespikes", exact: true, component: SpikeUniverseParentTab },
  { path: "/myspikes", exact: true, component: SpikeUniverseParentTab },
  {
    path: "/spikeswhalewatching",
    exact: true,
    component: SpikeUniverseParentTab,
  },
  { path: "/spikealerts", exact: true, component: SpikeUniverseParentTab },
  { path: "/add/explorespikes", exact: true, component: CreateSpikesWrapper },
  { path: "/add/selectspikes", exact: true, component: CreateSpikesWrapper },
  { path: "/add/reviewfinish", exact: true, component: CreateSpikesWrapper },
];

const ark_route_group = [
  {
    path: "/investor/:bid/fundamental",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/insider",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/alerts",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/technical",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/weightranking",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/trends",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/investor/:bid/performance",
    exact: true,
    component: InvestorArkParentTab,
  },
  {
    path: "/company/:bid/fundamental/:cid",
    exact: false,
    component: CompanyArkParentTab,
  },
  {
    path: "/company/:bid/insider/:cid",
    exact: true,
    component: CompanyArkParentTab,
  },
  {
    path: "/company/:bid/alerts/:cid",
    exact: true,
    component: CompanyArkParentTab,
  },
  {
    path: "/company/:bid/technical/:cid",
    exact: true,
    component: CompanyArkParentTab,
  },
  {
    path: "/company/:bid/willitspike/:cid",
    exact: true,
    component: CompanyArkParentTab,
  },
  {
    path: "/company/:bid/ownershiptrends/:cid",
    exact: true,
    component: CompanyArkParentTab,
  },
];

const funds_route_group = [
  { path: "/funds/:bid/fundamental", exact: true, component: FundsParentTab },
  { path: "/funds/:bid/insider", exact: true, component: FundsParentTab },
  { path: "/funds/:bid/alerts", exact: true, component: FundsParentTab },
  { path: "/funds/:bid/technical", exact: true, component: FundsParentTab },
  { path: "/funds/:bid", exact: true, component: FundsParentTab },
  { path: "/funds/:bid/:id", exact: true, component: FundsParentTab },

  // { path: "/funds/universe", exact: true, component: FundsParentTab },
  // { path: "/funds/sovereign", exact: true, component: FundsParentTab },
  // { path: "/funds/pension", exact: true, component: FundsParentTab },
  // { path: "/funds/retirement", exact: true, component: FundsParentTab },
  // { path: "/funds/billionaire", exact: true, component: FundsParentTab },
  // { path: "/funds/millionaire", exact: true, component: FundsParentTab },
  // { path: "/funds/whale", exact: true, component: FundsParentTab },
  // { path: "/funds/openinterest", exact: true, component: FundsParentTab },
];

const dashboard_new_route_group = [
  { path: "/dailybread", exact: true, component: Spike },
  { path: "/dailybread-new", exact: true, component: StocksAI },
  { path: "/resurrection", exact: true, component: Spike },
  { path: "/triangulation", exact: true, component: Spike },
  { path: "/goat", exact: true, component: StocksAI },
  { path: "/yolo", exact: true, component: StocksAI },
  { path: "/grit", exact: true, component: StocksAI },
  { path: "/trillion", exact: true, component: Spike },
  { path: "/buyback", exact: true, component: StocksAI },

  { path: "/stocks/dailybread", exact: true, component: Spike },
  { path: "/stocks/resurrection", exact: true, component: Spike },
  { path: "/stocks/triangulation", exact: true, component: Spike },
  { path: "/stocks/goat", exact: true, component: StocksAI },
  { path: "/stocks/yolo", exact: true, component: StocksAI },
  { path: "/stocks/grit", exact: true, component: StocksAI },
  { path: "/stocks/trillion", exact: true, component: Spike },
  { path: "/stocks/buyback", exact: true, component: StocksAI },
];

const options_new_route_group = [
  { path: "/options/open-interest", exact: true, component: Blocks },
  { path: "/options/block-quantity", exact: true, component: Blocks },
  { path: "/options/block-quality", exact: true, component: Blocks },
  { path: "/options/iv-change", exact: true, component: Blocks },
  { path: "/options/avg-volume", exact: true, component: Blocks },
  { path: "/options/leaps", exact: true, component: OptionsAI },
  {
    path: "/options/company/territory/:cid",
    exact: true,
    component: OptionsCompanyParentTab,
  },
  {
    path: "/options/company/interests/:cid",
    exact: true,
    component: OptionsCompanyParentTab,
  },
  {
    path: "/options/company/momentum/:cid",
    exact: true,
    component: OptionsCompanyParentTab,
  },
  {
    path: "/options/company/entryexit/:cid",
    exact: true,
    component: OptionsCompanyParentTab,
  },
  {
    path: "/options/company/willitspike/:cid",
    exact: true,
    component: OptionsCompanyParentTab,
  },
];

const lesson_route_group = [
  {
    path: "/lesson/:courseId/content/:lessonId",
    exact: false,
    component: LessonContainer,
  },
  {
    path: "/lesson/:courseId/content",
    exact: false,
    component: LessonContainer,
  },
];

const class_replays_route_group = [
  {
    path: "/classes/:zoom_meeting_id/replays",
    exact: true,
    component: ClassReplays,
  },
];

const cryptos_route_group = [
  { path: "/cryptos", exact: true, component: LegacyDailyBreadRedirect },
  {
    path: "/cryptos/candle/:cid",
    exact: true,
    component: LegacyDailyBreadRedirect,
  },
  {
    path: "/cryptos/owners/:cid",
    exact: true,
    component: LegacyDailyBreadRedirect,
  },
  {
    path: "/cryptos/insiders/:cid",
    exact: true,
    component: LegacyDailyBreadRedirect,
  },
  { path: "/cryptos/news/:cid", exact: true, component: LegacyDailyBreadRedirect },
];

const cryptos_2_route_group = [
  { path: "/wallet/:walletId", exact: true, component: Wallet },
  { path: "/crypto-coins", exact: true, component: LegacyDailyBreadRedirect },
  {
    path: "/crypto-coins/:blockchain",
    exact: true,
    component: LegacyDailyBreadRedirect,
  },
  { path: "/wallet", exact: true, component: UserWallet },
  { path: "/refer", exact: true, component: Referral },
  { path: "/blockchain", exact: true, component: BlockChain },
  { path: "/spin", exact: true, component: UserWallet },
  { path: "/track", exact: true, component: Track },
  { path: "/shop", exact: true, component: Shop },
];

const race_to_100_route_group = [
  { path: "/race-to-100", exact: true, component: LegacyDailyBreadRedirect },
];

const grabpay_group = [
  { path: "/checkout/grab-pay", exact: true, component: CheckoutGrabPay },
  { path: "/grab-pay/callback", exact: true, component: GrabPayCallback },
];

const challenge_events = [
  { path: "/challenge/:event_id/trading", exact: true, component: Trading },
  {
    path: "/challenge/:event_id/history",
    exact: true,
    component: EventHistory,
  },
  {
    path: "/challenge/:event_id/portfolio",
    exact: true,
    component: Portfolio,
  },
  {
    path: "/challenge/:event_id/history/:user_id",
    exact: true,
    component: EventHistory,
  },
  {
    path: "/challenge/:event_id/portfolio/:user_id",
    exact: true,
    component: Portfolio,
  },
  { path: "/challenge", exact: true, component: Challenge },
  {
    path: "/challenge/:event_id/performance",
    exact: true,
    component: ChallengePerformance,
  },
  {
    path: "/challenge/:event_id/leaderboard",
    exact: true,
    component: ChallengeLeaderboard,
  },
  {
    path: "/challenge/:event_id/performance/:user_id",
    exact: true,
    component: ChallengePerformanceComparison,
  },
  {
    path: "/challenge/:event_id/activity",
    exact: true,
    component: ChallengeActivity,
  },
  {
    path: "/challenge/:event_id/activity/:post_id",
    exact: true,
    component: ChallengeActivity,
  },
];

const copy_trades_route_group = [
  { path: "/copy-trade-portfolio", exact: true, component: CopyTradePortfolio },
  { path: "/discover", exact: true, component: DiscoverCopyTrade },
  {
    path: "/paper-trade/trade-portfolio",
    exact: true,
    component: TradePortfolio,
  },
  {
    path: "/paper-trade/trade-history",
    exact: true,
    component: TradeHistory,
  },
];

const user_profile = [
  {
    path: "/profile/personal-information",
    exact: true,
    component: PersonalInformation,
  },
  {
    path: "/profile/harada-method",
    exact: true,
    component: GridInput,
  },
  {
    path: "/profile/accomplishments",
    exact: true,
    component: Accomplishments,
  },
  {
    path: "/profile/trade-profile",
    exact: true,
    component: TradeProfile,
  },
  {
    path: "/profile/billing",
    exact: true,
    component: Billing,
  },
  {
    path: "/profile/subscriptions",
    exact: true,
    component: Subscriptions,
  },
  {
    path: "/profile/calendar",
    exact: true,
    component: ProfileCalendar,
  },
  {
    path: "/profile/notification",
    exact: true,
    component: ProfileNotification,
  },
  {
    path: "/profile/danger-zone",
    exact: true,
    component: DangerZone,
  },
  {
    path: "/profile/following",
    exact: true,
    component: Following,
  },
  {
    path: "/profile/trading-diary",
    exact: true,
    component: TradingDiary,
  },
  {
    path: "/profile/membership",
    exact: true,
    component: Membership,
  },
  {
    path: "/code",
    exact: true,
    component: CodeOfHonor,
  },
  {
    path: "/profile/code",
    exact: true,
    component: () => <Redirect to="/code" />,
  },
];

const ReplaysRedirect = () => <Redirect to="/courses" />;

const video_library_route_group = [
  {
    path: "/video-library",
    exact: false,
    component: VideoLibrary,
    redirect: "https://spiking.com/help",
  },
  { path: "/replays", exact: true, component: ReplaysRedirect },
];

const million_dollar_trade = [
  {
    path: "/million-dollar-trades",
    exact: true,
    component: MillionDollarTrade,
  },
];

const spiking_upDown_route_group = [
  { path: "/spiking-up-down", exact: true, component: Spike },
  { path: "/dividend", exact: true, component: SpikingUpDown },
];

const discover_route_group = [
  { path: "/overview", exact: true, component: Discover },
  { path: "/stocks-ai", exact: true, component: Discover },
  { path: "/options-ai", exact: true, component: Discover },
  { path: "/cryptos-ai", exact: true, component: Discover },
];

const YearInReview2025 = React.lazy(() => import("../../YearInReview2025"));

const discoverNew_route_group = [
  { path: "/your-future", exact: true, component: Journey },
  { path: "/your-futureATV", exact: true, component: JourneyATV },
  { path: "/journey", exact: true, component: DiscoverNew },
  { path: "/support", exact: true, component: Journey },
  { path: "/kickoff", exact: true, component: Kickoff },
  { path: "/2025-year-in-review", exact: true, component: YearInReview2025 },
];


const other_route_group = [
  { path: "/home", component: Home },
  { path: "/popularspikes", component: PopularSpikes },
  { path: "/popularinsiders", component: PopularInsidersParentTab },
  { path: "/notifications", component: Notification },
  { path: "/notification", component: SingleNotificationContainer },
  { path: "/videos", component: VideosParentTab },
  { path: "/videoplay", component: VideoPlay },
  { path: "/receipt", exact: true, component: WebPurchaseComp },
  { path: "/filling-date", exact: true, component: Calendar },
  { path: "/bluewhale-company/:id", component: LeaderboardTable },
  { path: "/server-error", component: ServerError },
  { path: "/check", exact: true, component: CheckPrivatePublic },
  { path: "/agreetoterms", exact: true, component: TermsAndConditions },
  { path: "/user-details", exact: true, component: AppleUserDetails },
  { path: "/wisdom", exact: true, component: Wisdom },
  { path: "/welcome-crypto", exact: true, component: WelcomeCrypto },
  { path: "/members-area/:product_id?", exact: true, component: MembersArea },
  { path: "/advance", exact: true, component: AdvanceRoute },
  { path: "/advance-cryptos", exact: true, component: AdvanceRoute },
  { path: "/advance-options", exact: true, component: AdvanceRoute },
  { path: "/ark", exact: true, component: Line },
  { path: "/bar", exact: true, component: Bar },
  { path: "/tree", exact: true, component: Tree },
  { path: "/trends", exact: true, component: Trends },
  // { path: "/crypto", exact: false, component: Crypto },
  { path: "/layout", exact: true, component: LayoutRoute },
  {
    path: "/share",
    exact: true,
    component: YourReferralLinkNew,
  },
  {
    path: "/referral/referral-settings",
    exact: true,
    component: PaypalSuccessfulRefNew,
  },
  { path: "/course/:courseId", component: BasicCourse },
  { path: "/tradegpt", exact: true, component: TradeGPT },
  { path: "/tradegpt-sectors", exact: true, component: TradeGptSectors },
  { path: "/prompt", exact: true, component: TradeGptPrompt },
  { path: "/prompt-before", exact: true, component: TradeGptPrompt },
  { path: "/holygrail", exact: true, component: HolyGrail },
  { path: "/holygrail-options", exact: true, component: HolyGrail },
  { path: "/holygrail-cryptos", exact: true, component: HolyGrail },
  { path: "/events-calendar", exact: true, component: EventsCalendar },
  { path: "/workbook", exact: true, component: Workbook },
  { path: "/newsletter", exact: true, component: Newsletter },
  { path: "/holygrail-wealth", exact: true, component: HolyGrail },
  { path: "/holygrail-ai", exact: true, component: HolyGrail },
  { path: "/top-10-buy", exact: true, component: TopBuySell },
  { path: "/top-10-sell", exact: true, component: TopBuySell },
  { path: "/stock-performance", exact: true, component: StockPerformance },
  { path: "/crypto/hodl", component: HodlPage },
  { path: "/crypto/tools", component: HodlPage },
  { path: "/property/tools", component: PropertyToolsPage },
  { path: "/property", component: LandPage },

  { path: "/system-update", component: SystemUpdate },
];

const public_product_route_group = [
  { path: "/sectors", exact: true, component: PublicSectorPage },
  { path: "/sectors/:sectorId", exact: true, component: PublicSectorPage },
  {
    path: "/holygrail/:holyGrailId",
    exact: true,
    component: PublicHolyGrailPage,
  },
  { path: "/daily-bread", exact: true, component: PublicDailyBreadPage },
  { path: "/top-30-ai-stocks", exact: true, component: Top30AIStockPage },
  { path: "/ytd", exact: true, component: PublicYTDPage },
  { path: "/ytd/:categoryId", exact: true, component: PublicYTDPage },
  { path: "/200-sma", exact: true, component: Public200SMAPPage },
];

const getPrivateRoutes = () => {
  return [
    ...dailytrades_route_group,
    ...company_route_group,
    // ...dashboard_route_group,
    ...investor_route_group,
    ...baiting_route_group,
    ...spike_universe_route_group,
    // ...learn_route_group,
    ...other_route_group,
    ...funds_route_group,
    ...dashboard_new_route_group,
    ...options_new_route_group,
    ...courses_route_group_private,
    ...lesson_route_group,
    ...class_replays_route_group,
    ...user_profile,
    ...copy_trades_route_group,
    ...race_to_100_route_group,
    // ...(isToken() ? video_library_route_group : []),
    ...video_library_route_group,
    ...million_dollar_trade,
    ...spiking_upDown_route_group,
    ...discover_route_group,
    ...discoverNew_route_group,
    ...cryptos_2_route_group,
    ...cryptos_route_group,
  ];
};

const ReferralLinkRedirect = () => <Redirect to="/refer" />;

const claude_route_group = [
  { path: "/claude/smart-money", exact: true, component: SmartMoneyMarginScreen },
  { path: "/claude/portfolio-risk", exact: true, component: PortfolioRiskDashboard },
];

const getPublicRoutes = () => {
  return [
    // { path: "/login", exact: true, component: Login },
    { path: "/login", exact: true, component: LoginLandingPage },
    { path: "/loginatv", exact: true, component: ATVLoginPage },
    { path: "/login-old", exact: true, component: Login },
    { path: "/email-login", exact: true, component: EmailLogin },
    { path: "/create-account", exact: true, component: CreateAccount },
    { path: "/forgot-password", exact: true, component: ForgotPassword },
    { path: "/reset-password", exact: true, component: ResetPassword },
    { path: "/magic-link", exact: true, component: MagicLink },
    { path: "/react", exact: true, component: Intermediate },
    { path: "/logout", exact: true, component: LogoutContainer },
    { path: "/courses", exact: true, component: CoursesNew },
    { path: "/race", exact: true, component: LegacyDailyBreadRedirect },
    { path: "/calendar", exact: true, component: EventCalendarContainer },
    { path: "/disclaimer", component: Disclaimer },
    { path: "/btc", exact: true, component: NewCryptos },
    { path: "/youtube/:videoId", exact: true, component: YoutubePlayer },
    {
      path: "/auth/wechat/callback",
      exact: true,
      component: AuthWeChatCallback,
    },
    {
      path: "/referral/your-referral-link",
      exact: true,
      component: ReferralLinkRedirect,
    },
    { path: "/harada/:id", exact: true, component: PublicHaradaView },
    { path: "/pricing-premium", exact: true, component: PricingPremium },
    { path: "/optionstrading", exact: true, component: OptionsTradingLanding },
    { path: "/56", exact: true, component: Options56Landing },
    ...ark_route_group,
    ...grabpay_group,
    ...public_product_route_group,
    ...claude_route_group,
  ];
};

// const private_route_group = [
//   ...dailytrades_route_group,
//   ...company_route_group,
//   ...dashboard_route_group,
//   ...investor_route_group,
//   ...baiting_route_group,
//   ...spike_universe_route_group,
//   // ...learn_route_group,
//   ...other_route_group,
//   ...funds_route_group,
//   ...dashboard_new_route_group,
//   ...options_new_route_group,
//   ...courses_route_group_private,
//   ...lesson_route_group,
//   ...cryptos_route_group,
//   ...activity_feed_route_group,
//   ...challenge_events,
//   ...user_profile,
//   ...copy_trades_route_group,
//   ...race_to_100_route_group,
//   ...video_library_route_group,
// ];

// const public_route_group = [
//   // { path: "/login", exact: true, component: Login },
//   { path: "/login", exact: true, component: LoginLandingPage },
//   { path: "/login-old", exact: true, component: Login },
//   { path: "/email-login", exact: true, component: EmailLogin },
//   { path: "/create-account", exact: true, component: CreateAccount },
//   { path: "/forgot-password", exact: true, component: ForgotPassword },
//   { path: "/reset-password", exact: true, component: ResetPassword },
//   { path: "/react", exact: true, component: Intermediate },
//   { path: "/logout", exact: true, component: LogoutContainer },
//   { path: "/race", exact: true, component: RaceTo100 },
//   { path: "/library", exact: false, component: VideoLibrary },
//   ...ark_route_group,
//   ...grabpay_group,
// ];

const affiliate_route_group = [
  { path: "/insiders/:insiderId?", exact: true, component: InsiderMember },
  {
    path: "/insiders/checkout/:insider_id?",
    exact: true,
    component: InsiderCheckout,
  },
  { path: "/welcomeInsider/:insider_id", component: WelcomeInsider },
  { path: "/membership/:id", component: CheckoutNew },
  { path: "/courses/:id", component: CheckoutNew },
  { path: "/redirect", component: AffiliateRedirect },
];

const AllRoutes = (props) => {
  // const { user } = props;
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={() => {
          if (isToken()) return <Redirect to="/check" />;
          else return <Redirect to="/login" />;
        }}
      />
      {getPublicRoutes().map((route, idx) => (
        // <Route
        //   key={idx}
        //   path={route.path}
        //   exact={route.exact}
        //   component={route.component}
        // />
        <PublicRoute
          key={idx}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
      {getPrivateRoutes().map((route, id) => (
        <PrivateRoute
          redirect={route.redirect}
          key={id}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
      {affiliate_route_group.map((route, id) => (
        <AffiliateRoute
          key={id}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
      {/*TODO - Single crypto route*/}
      {/* <Route path={"/crypto"} component={Crypto} /> */}
      <Route component={PageNotFound} />
    </Switch>
  );
};

// AllRoutes.propTypes = {
//   user: PropTypes.object
// }

export default AllRoutes;
